import { makeErrorBoundary } from '@pdcplan/shared/components';
import getApi from '../getApi';

const ErrorBoundary = makeErrorBoundary(getApi());

export default ErrorBoundary;

